import type { ElementType, ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import {
  FontColorType,
  getFontColorClassName,
  getTextAlignClassName,
  type TextAlignment,
  type StylesProp,
  splitStylesProp,
} from '../../helpers';
import { HeadingStyles } from './heading.styles';

export interface HeadingProps extends CommonHTMLAttributes {
  as?: ElementType;
  children?: ReactNode;
  className?: string;
  color?: FontColorType;
  level?: 1 | 2 | 3;
  textAlign?: TextAlignment;
  css?: StylesProp;
}

const HTML_TAG_MAP = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
};

export function Heading({
  level = 1,
  color = 'default',
  textAlign = 'left',
  className,
  css,
  as,
  ...props
}: HeadingProps) {
  const Component = !!as ? as : HTML_TAG_MAP[level];
  const headingStyles = HeadingStyles.heading({ level });

  const { css: headingCss, className: headingClassName } = splitStylesProp(css);

  return (
    <Component
      className={cx(
        ...headingStyles,
        getFontColorClassName(color),
        getTextAlignClassName(textAlign),
        className,
        headingClassName
      )}
      css={headingCss}
      {...props}
    />
  );
}
